import React from "react";

const ClinicalSegmintTab = ({ Segments = [], FieldApplication = [] }) => {
  // const Segments = [
  //   "Abdomen and Liver",
  //   "Pediatrics",
  //   "Critical Care",
  //   "Regional Anesthesia and Pain Medicine",
  //   "Emergency Medicine",
  //   "Thyroid and Testes (Small Parts)",
  //   "Musculoskeletal",
  //   "Vascular",
  // ];

  // const FieldApplication = [
  //   "General Imaging",
  //   "Obstetrics and Gynecology",
  //   "Point of Care",
  // ];

  return (
    <div className="py-5 ">
      <div className="mt-5">
        {Segments.length > 0 && (
          <ul className="space-y-3 list-disc mt-4 pl-4 text-sm text-gray-800 grid grid-cols-1 md:grid-cols-2 gap-4 md:mx-20 ">
            {Segments.map((detail, index) => (
              <li className="flex items-start text-left" key={index}>
                <svg
                  className="w-4 h-4 mr-2 text-primary-color flex-shrink-0"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                </svg>
                {detail}
              </li>
            ))}
          </ul>
        )}
        <br />
        {FieldApplication.length > 0 && (
          <div className="mt-5 md:px-20">
            <h3 className="text-[20px] font-[500] text-gray-800 text-left ">
              Field of Application:
            </h3>
            <ul className="space-y-3 list-disc list-inside mt-4 pl-4 text-sm text-gray-800">
              {FieldApplication.map((benefit, index) => (
                <li className="text-left" key={index}>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClinicalSegmintTab;
